import { MediaSrc } from '@challenger6/vm-pattern-library/media/media-src.type';
import { IconWeight } from '../../models/icon-weight.enum';

export class GenericTileModel {
  title: string;
  info?: string;
  label?: string;
  isSelected?: boolean;
  isSelectable?: true;
  icon?: string;
  iconColor?: string;
  iconWeight?: IconWeight;
  iconSrc?: string | MediaSrc;
  iconSrcWidth?: string;
  iconSrcHeight?: string;
  iconSize?: string = 'sm';
  inputValue?: string;
  type?: string;
  id?: string;
  uid?: string;
  isModalOpen?: boolean = false;
  modalTitle?: string;
  modalCopy?: string;
}

export enum GenericTileType {
  TILE_WITH_IMAGE = 'tile-with-image',
  TILE_WITH_ICON = 'tile-with-icon',
  TILE_WITH_RADIO = 'tile-with-radio',
}
